import { BfxBlotterOrdersContextMenuItemDuplicateState } from "./BfxBlotterOrdersContextMenuItemDuplicateState";

import { BfxBlotterOrdersContextMenuState } from "./BfxBlotterOrdersContextMenuState";
import { BfxBlotterOrdersContextMenuItem } from "./BfxBlotterOrdersContextMenuItem";

import { BfxBlotterAction } from "../bfx-base-blotter/BfxBlotterAction";

import { ContextMenuItemState } from "../ContextMenuItemState";
import { ContextMenuItemStateCommand } from "../ContextMenuItemStateCommand";
import { ContextMenuItemStateCommandCriteria } from "../ContextMenuItemStateCommandCriteria";
import { ContextMenuState } from "../ContextMenuState";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { SiblingRelationship } from "shared/cubiq-services/lookup/model/impl/SiblingRelationshipManager";

export class BfxBlotterOrdersContextMenuDuplicateItem extends BfxBlotterOrdersContextMenuItem {
  constructor() {
    super(
      BfxBlotterAction.ACTION_ORDER_DUPLICATE,
      "Duplicate",
      BfxBlotterOrdersContextMenuDuplicateItem.checkAvailableFn(),
      BfxBlotterOrdersContextMenuDuplicateItem.checkEnabledFn(),
      ContextMenuItemStateCommandCriteria.MenuItem,
      ContextMenuItemStateCommandCriteria.Item,
    );
  }

  public reset(): void {
    let oldState = this.state;
    this.state = new BfxBlotterOrdersContextMenuItemDuplicateState();
    this.state.title = oldState.title;
  }

  private static checkAvailableFn(): ContextMenuItemStateCommand<CubiqTS.OrderDataImpl> {
    return function (
      this: void,
      menuState: BfxBlotterOrdersContextMenuState,
      itemState: ContextMenuItemState,
    ) {
      itemState.available = menuState.canViewOrderEntry; // || menuState.canEnterOrdersUnrestricted  || menuState.canEnterOrder;
    };
  }

  private static checkEnabledFn(): ContextMenuItemStateCommand<CubiqTS.OrderDataImpl> {
    return function (
      this: void,
      menuState: BfxBlotterOrdersContextMenuState,
      itemState: BfxBlotterOrdersContextMenuItemDuplicateState,
      item: CubiqTS.OrderDataImpl,
    ) {
      itemState.enabled = itemState.available && menuState.count == 1;

      if (item && CubiqTS.StrategyType.GAMMA == item.strategyType) {
        let gammaEnabled: boolean = BfxBlotterOrdersContextMenuDuplicateItem.checkGammaMidLeg(item);
        itemState.enabled = itemState.enabled && gammaEnabled;
      }
    };
  }

  private static checkSelectionCount(
    item: CubiqTS.OrderDataImpl,
    menuState: BfxBlotterOrdersContextMenuState,
  ): boolean {
    let enabled: boolean = true;
    if (menuState != null && menuState.count != null && menuState.count > 1) {
      enabled = false;
    }
    return enabled;
  }

  public static checkGammaMidLeg(item: CubiqTS.OrderDataImpl): boolean {
    let midLegActive: boolean = false;

    if (item && CubiqTS.StrategyType.GAMMA == item.strategyType) {
      const gammaRelationship = item.siblingRelationship as SiblingRelationship;

      if (gammaRelationship != null && Array.isArray(gammaRelationship.siblingOrders)) {
        let rungs: CubiqTS.OrderDataImpl[] = gammaRelationship.siblingOrders;
        midLegActive = rungs.some((r) => r.orderState == CubiqTS.OrderState.GAMMA_MID_PENDING);
      }

      return midLegActive;
    }

    return midLegActive;
  }

  public static get state(): any {
    return new BfxBlotterOrdersContextMenuItemDuplicateState();
  }
}
